import { useNavigate, useParams } from '@tanstack/react-router'
import { MailIcon } from 'lucide-react'

import { Text } from '@/components/ui/text'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

interface LastEmailProps {
  subject?: string
  content?: string
  messageId?: string
  applicationId: string
}

export function LastEmail({ applicationId, content, messageId, subject }: LastEmailProps) {
  const { jobId } = useParams({ from: '/_authenticated/jobs_/$jobId' })
  const navigate = useNavigate()

  return (
    <Tooltip disableHoverableContent>
      <TooltipTrigger asChild>
        <button
          onClick={async (e) => {
            e.preventDefault()
            e.stopPropagation()
            if (messageId) {
              await navigate({
                params: { applicationId, jobId },
                search: { messageId, view: 'emails' },
                to: '/jobs/$jobId/applications/$applicationId',
              })
            }
          }}
        >
          <MailIcon className="size-4 text-muted-foreground/80" />
        </button>
      </TooltipTrigger>
      <TooltipContent align="start" className="max-w-80 space-y-2">
        {subject && content && messageId ? (
          <>
            <div>
              <Text size="xs" variant="white" weight="semibold">
                Subject:
              </Text>
              <Text size="xs" truncate variant="white">
                {subject}
              </Text>
            </div>
            <div>
              <Text size="xs" variant="white" weight="semibold">
                Content:
              </Text>
              <div className="truncate">{content}</div>
            </div>
          </>
        ) : (
          <Text size="xs" variant="white">
            No email
          </Text>
        )}
      </TooltipContent>
    </Tooltip>
  )
}
